import { Box, Grid, Typography, Card, CardContent, CardMedia, useMediaQuery } from "@mui/material";
import selfRelianceImage from '../../assets/image/landing/self-reliance.png';
import innovationImage from '../../assets/image/landing/innovation.png';
import integrityImage from '../../assets/image/landing/integrity.png';
import collaborationImage from '../../assets/image/landing/collaboration.png';

const values = [
    {
        title: "Self-Reliance",
        description: "Focus on local production and innovation to strengthen national defense capabilities.",
        imageUrl: selfRelianceImage,
    },
    {
        title: "Innovation",
        description: "Commit to continuous product development and technological advancement.",
        imageUrl: innovationImage,
    },
    {
        title: "Integrity",
        description: "Uphold transparency, accountability, and ethics in all business operations.",
        imageUrl: integrityImage,
    },
    {
        title: "Collaboration",
        description: "Establish strong partnerships with local and international entities to deliver superior defense solutions.",
        imageUrl: collaborationImage,
    },
];

const LandingCoreValuesComponent = () => {

    const isSmallScreen = useMediaQuery('(max-width:600px)'); 

    return (
        <div style={{ backgroundColor: '#ffffff', padding: 28 }}>
            <Grid container>
                <Grid item xs={12}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: 60, textAlign: 'center', color: '#08244d', mt: 2, mb: 2 }}>
                        Core Values
                    </Typography>
                    <br />
                </Grid>
            </Grid>
            <Box sx={{ pl: isSmallScreen ? 0 : 16, pr: isSmallScreen ? 0 :  16, display: 'flex' }}>
                <Grid container spacing={8}>
                    {values.map((value, index) => (
                        <Grid item xs={12} sm={12} md={6} key={index} >
                            <Card sx={{ display: isSmallScreen ? 'block' : 'flex', borderRadius: '8px', border: '1px solid #d9d9d9' }}>
                                <CardMedia
                                    component="img"
                                    sx={{ width: isSmallScreen ? '100%' : 280, height: isSmallScreen ? '100%' : 280, objectFit: 'cover', borderRadius: '8px' }}
                                    image={value.imageUrl}
                                    alt={value.title}
                                />
                                <Box sx={{ display:  'flex', flexDirection: 'column', justifyContent: 'center', padding: 2, textAlign: 'start' }}>
                                    <CardContent>
                                        <Typography sx={{ fontWeight: 'bold', fontSize:  28, color: '#08244d' }}>
                                            {value.title}
                                        </Typography>
                                        <br />
                                        <Typography sx={{ fontSize: 20, color: '#08244d' }}>
                                            {value.description}
                                        </Typography>
                                    </CardContent>
                                </Box>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </div>
    );
}

export default LandingCoreValuesComponent;
